<template>
  <rid-field
    :label="application.kind"
    icon="mdi-text-box-check-outline"
    :value="
      (application.number ?? '&mdash;') +
      ' от ' +
      (application.date ? formatDate(application.date) : '&mdash;')
    "
  />
  <rid-field
    v-if="(application.pctNumber || application.pctDate) && !compact"
    label="Заявка PCT"
    icon="mdi-web"
    :value="
      (application.pctNumber ?? '&mdash;') +
      ' от ' +
      (application.pctDate ? formatDate(application.pctDate) : '&mdash;')
    "
  />
</template>

<script setup>
import moment from 'moment/moment'
import RidField from '@/components/Rid/RidField.vue'

defineProps({
  application: {
    type: Object,
    required: true,
  },
  compact: {
    type: Boolean,
    required: true,
  },
})

const formatDate = (unixtime) => moment.unix(unixtime).format('YYYY-MM-DD')
</script>

<style scoped lang="scss">

</style>
